export type InstrumentKind =
  'piano' | 'vocal' | 'guitar' | 'electric-guitar' | 'drums' | 'handpan' | 'violin';

const KINDS: readonly InstrumentKind[] = [
  'piano',
  'vocal',
  'guitar',
  'electric-guitar',
  'drums',
  'handpan',
  'violin',
];

const BY_ICON: Record<string, InstrumentKind> = {
  mic: 'vocal',
  drum: 'drums',
  guitar: 'guitar',
  violin: 'violin',
  handpan: 'handpan',
};

export function instrumentKind(slug: string, icon: string): InstrumentKind {
  return KINDS.find((kind) => kind === slug) ?? BY_ICON[icon] ?? 'piano';
}
